import * as React from 'react';
import type { SVGProps } from 'react';

interface HemlockLogoProps extends SVGProps<SVGSVGElement> {
  primaryColor?: string;
  secondaryColor?: string;
  dividerColor?: string;
}

const SvgHemlockLogo = ({
  primaryColor = '#3752B3',
  secondaryColor = '#26368A',
  dividerColor = '#BBCAE2',
  ...props
}: HemlockLogoProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={207}
    height={32}
    fill="none"
    viewBox="0 0 207 32"
    {...props}
  >
    <path
      fill={primaryColor}
      d="M194.689 23V4.8h3.172v10.53c.26-.364.624-.806.91-1.118l3.64-3.9h4.134l-5.278 5.408 5.642 7.28h-4.056l-3.692-5.122-1.3 1.326V23zM185.829 23.468c-4.03 0-6.422-2.6-6.422-6.812 0-4.238 2.886-6.76 6.578-6.76s5.694 2.236 6.006 5.2h-3.224c-.104-1.43-.988-2.678-2.782-2.678-1.846 0-3.354 1.508-3.354 4.264 0 2.522 1.326 4.29 3.276 4.29 1.924 0 2.834-1.3 2.99-2.808h3.224c-.442 3.224-2.522 5.304-6.292 5.304M170.844 23.468c-3.822 0-6.5-2.548-6.5-6.76 0-4.16 2.704-6.812 6.5-6.812 3.822 0 6.526 2.652 6.526 6.812 0 4.212-2.704 6.76-6.526 6.76m-3.276-6.76c0 2.704 1.3 4.264 3.276 4.264s3.302-1.56 3.302-4.264c0-2.756-1.352-4.29-3.302-4.29-1.924 0-3.276 1.534-3.276 4.29M158.414 23V4.8h3.172V23zM136.495 23V10.312h3.172v.572c0 .39-.026.832-.104 1.248.624-1.118 1.794-2.236 3.666-2.236 1.586 0 2.86 1.222 3.328 2.366.728-1.222 2.262-2.366 4.108-2.366 2.574 0 4.368 2.028 4.368 5.122V23h-3.172v-7.514c0-1.846-.728-3.068-2.106-3.068s-2.418 1.274-2.418 3.198V23h-3.172v-7.514c0-1.846-.676-3.068-2.106-3.068-1.378 0-2.392 1.222-2.392 3.198V23zM127.686 23.468c-3.796 0-6.474-2.444-6.474-6.838 0-4.004 2.678-6.734 6.37-6.734 3.874 0 6.11 2.704 6.11 6.838v.702h-9.23c.026 2.002 1.3 3.536 3.224 3.536 1.378 0 2.496-.78 2.704-2.106h3.224c-.26 2.6-2.496 4.602-5.928 4.602m-3.25-8.32h6.006c-.052-1.716-1.17-2.886-2.886-2.886s-2.938 1.222-3.12 2.886M103.002 23V4.8h3.406v7.436h8.398V4.8h3.406V23h-3.406v-7.878h-8.398V23z"
    />
    <path
      fill={secondaryColor}
      d="M17.637 4.96v18.385H14.36V12.5L9.977 23.345H7.53L3.148 12.5v10.844H0V4.96h3.812l5.01 13.128 5.01-13.128zm39.426-.738L57.027 4h-.982l-2.454 2.843V9.05h-2.534V12.1h2.534v7.836c0 2.098.577 3.401 3.429 3.401h3.17v-3.122h-3.127v-8.108h3.646V9.05h-3.646zm13.522 13.937-3.71-9.11h-3.682l5.617 13.458-.889 2.249h-3.118V28h1.92c2.484 0 3.473-.358 4.368-2.485L78 9.042h-3.696zm-38.068-1.962c0-3.115-2.26-4.534-4.36-4.534-2.102 0-4.361 1.418-4.361 4.534s2.26 4.534 4.36 4.534 4.36-1.419 4.36-4.534m-4.36-7.663c4.331 0 7.724 3.366 7.724 7.663s-3.393 7.663-7.725 7.663-7.725-3.366-7.725-7.663 3.393-7.663 7.725-7.663m16.82 0c-1.356 0-2.57.594-3.039 2.012 0 0 0 .007-.007.007v-.043l-.166-1.468h-3.04v14.295h3.473V13.67c0-1.597.607-2.457 1.697-2.457.982 0 1.473.688 1.473 2.041v1.948h3.472v-2.148c0-2.872-1.408-4.52-3.862-4.52"
    />
    <path
      fill={dividerColor}
      fillRule="evenodd"
      d="M89 32V0h1v32z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHemlockLogo;
